export default "__VITE_ASSET__DguosefA__"